import { Box, Typography } from '@mui/material'

interface NoDataSectionProps {
    title: string
    message: string
}

export const NoDataSection: React.FC<NoDataSectionProps> = ({ title, message }) => {
    return (
        <Box
            sx={{
                backgroundColor: '#FFF',
                display: 'flex',
                borderTop: '1px solid',
                borderColor: 'grey.200'
            }}
        >
            <Box
                sx={{
                    py: 2,
                    pl: 2,
                    pr: 1,
                    flex: 1,
                    borderRight: '1px solid',
                    borderColor: 'grey.200'
                }}
            >
                <Typography sx={{ fontWeight: 600, fontSize: { sm: 14, md: 16 } }}>{title}</Typography>
            </Box>

            <Box sx={{ flex: 2, p: 2 }}>
                <Typography sx={{ fontSize: { sm: 12, md: 14 } }}>{message}</Typography>
            </Box>
        </Box>
    )
}
